import { Box, Grid, Typography } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import dynamic from 'next/dynamic';

import useCustomMediaQuery from 'hooks/useCustomMediaQuery';

const BaseContainer = dynamic(() => import('layout/Main/container'));

const useStyles = makeStyles((theme) => ({
	wrapperCoverStore: {
		maxHeight: '25.2rem',
		height: '25.2rem',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignContent: 'center',
		alignItems: 'center',
		background: `linear-gradient(111.02deg, ${theme.palette.primary[900]} 12.25%, ${theme.palette.primary[800]} 100.52%, ${theme.palette.primary[800]} 100.52%)`,
		[theme.breakpoints.between('xs', 'sm')]: {
			minHeight: '19.9rem',
			maxHeight: '19.9rem',
		},
	},
	coverStoreTitle: {
		marginTop: '',
		[theme.breakpoints.between('xs', 'sm')]: {
			margin: '4.8rem 0 0.8rem 0',
		},
	},
	coverStoreSubTitle: {
		[theme.breakpoints.between('xs', 'sm')]: {
			margin: '0 0 4.8rem 0',
		},
	},
}));

const CoverCommon = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const { isMobile } = useCustomMediaQuery();

	return (
		<Box className={classes.wrapperCoverStore} {...(props.bg && { background: props.bg })}>
			<Grid container>
				<BaseContainer>
					<Grid xs={12} item>
						<Box display={'flex'} flexDirection="column" justifyContent={'center'} alignContent="center">
							<Typography
								textAlign="center"
								fontWeight={700}
								variant={isMobile ? 'h4' : 'h3'}
								lineHeight={'5rem'}
								className={classes.coverStoreTitle}
							>
								{props.title}
							</Typography>
							<Typography
								textAlign="center"
								lineHeight={'2.2rem'}
								fontWeight={500}
								variant={isMobile ? 'subtitle2' : 'subtitle1'}
								color={theme.palette.text.disabled}
								className={classes.coverStoreSubTitle}
							>
								{props.subTitle}
							</Typography>
						</Box>
					</Grid>
				</BaseContainer>
			</Grid>
		</Box>
	);
};

export default CoverCommon;
